
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { AuthContainer } from "@/components/auth/AuthContainer";
import { AuthHeader } from "@/components/auth/AuthHeader";
import { AuthForm } from "@/components/auth/AuthForm";

type AuthView = 'sign_in' | 'sign_up' | 'update_password';

interface AuthProps {
  view?: AuthView;
}

const Auth = ({ view = 'sign_in' }: AuthProps) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [currentView, setCurrentView] = useState<AuthView>(view);

  useEffect(() => {
    console.log("=== Auth component mounted ===");
    
    // Handle recovery flow
    const type = searchParams.get('type');
    if (type === 'recovery') {
      setCurrentView('update_password');
      return; // Skip session check for recovery flow
    }
    
    const checkSession = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (session) {
        console.log("User already authenticated, redirecting to home");
        navigate("/");
      }
    };
    
    checkSession();
    
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      async (event, session) => {
        console.log("Auth state changed:", event);
        
        if (event === 'SIGNED_IN' && session) {
          // Don't redirect if we're in recovery flow
          if (type !== 'recovery') {
            navigate("/");
          }
        }
      }
    );

    return () => {
      console.log("Cleaning up auth state listener");
      subscription.unsubscribe();
    };
  }, [navigate, searchParams]);

  return (
    <AuthContainer>
      <AuthHeader view={currentView} />
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <AuthForm view={currentView} />
      </div>
    </AuthContainer>
  );
};

export default Auth;
